import moment from 'moment'
import qs from 'qs'
import oikosApi from '../../../services/oikos'
import { getReg, insert, printStandardEmail, sendEmailToNotify, updateField } from '../../../utils/fc'

const RH_EMAIL = 'rh@ecossis.com.br'

const BOOL_LABEL = (v) => (v === 1 || v === true ? 'Sim' : v === 0 || v === false ? 'Não' : '-')

const formatDate = (v) => (v ? moment(v).format('DD/MM/YYYY') : '-')

const formatCurrency = (v) => {
  if (v === null || v === undefined || v === '') return '-'
  const n = Number(v)
  if (Number.isNaN(n)) return String(v)
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

export function buildFichaPjEmailHtml(pf, form) {
  const estrutura = Array.isArray(form.estrutura) && form.estrutura.length
    ? form.estrutura.join(', ')
    : '-'
  const documentos = Array.isArray(form.documentos) && form.documentos.length
    ? form.documentos.join(', ')
    : '-'

  return printStandardEmail(`
    <p><strong>Nova Ficha Cadastral PJ — Prestador de Serviços</strong></p>
    <p><strong>Colaborador vinculado:</strong> ${pf.pf_nomeExibicao || '-'} (pf_id: ${pf.pf_id})</p>
    <p><strong>E-mail do colaborador:</strong> ${pf.pf_emailProf || '-'}</p>
    <hr />
    <p><strong>DADOS CADASTRAIS</strong></p>
    <p>Razão Social: ${form.razaoSocial || '-'}<br />
    CNPJ: ${form.cnpj || '-'}<br />
    Nome Fantasia: ${form.nomeFantasia || '-'}<br />
    Data de abertura: ${formatDate(form.dtAbertura)}<br />
    Inscrição Municipal: ${form.inscMunicipal || '-'}<br />
    Inscrição Estadual: ${form.inscEstadual || '-'} ${form.inscEstadualIsento ? '(ISENTO)' : ''}</p>
    <p><strong>CONTATO</strong></p>
    <p>Endereço: ${form.endereco || '-'}, ${form.numero || '-'} ${form.complemento || ''}<br />
    Bairro: ${form.bairro || '-'} — ${form.cidade || '-'}/${form.estado || '-'} — CEP: ${form.cep || '-'}<br />
    Telefone: ${form.telefone || '-'} | Celular: ${form.celular || '-'} | Comercial: ${form.telComercial || '-'}<br />
    E-mail: ${form.email || '-'}<br />
    Observação: ${form.obs || '-'}</p>
    <p><strong>TIPO DE SERVIÇO:</strong> ${form.tipoServico || '-'}</p>
    <p>Porte: ${form.porte || '-'} | Ramo: ${form.ramo || '-'} | Simples Nacional: ${BOOL_LABEL(form.optanteSimples)}</p>
    <p><strong>DADOS BANCÁRIOS</strong></p>
    <p>Banco: ${form.banco || '-'} | Agência: ${form.agencia || '-'} | Conta: ${form.contaNum || '-'} (${form.contaTp || '-'})</p>
    <p><strong>ESTRUTURA ALOCADA:</strong> ${estrutura}</p>
    <p><strong>INFORMAÇÕES COMPLEMENTARES</strong></p>
    <p>Possui contador: ${BOOL_LABEL(form.possuiContador)}<br />
    Possui colaboradores/sócios/terceiros: ${BOOL_LABEL(form.possuiColaboradores)}<br />
    Faturamento médio mensal: ${formatCurrency(form.faturamentoMedio)}<br />
    Nº de clientes ativos: ${form.numClientes || '-'}</p>
    <p><strong>REPRESENTANTE LEGAL</strong></p>
    <p>Nome: ${form.repNome || '-'}<br />
    Data de Nascimento: ${formatDate(form.repDtNasc)}<br />
    CPF: ${form.repCpf || '-'} | Formação: ${form.repFormacao || '-'}<br />
    Celular: ${form.repCelular || '-'} | WhatsApp: ${form.repWhatsapp || '-'}<br />
    Endereço: ${form.repEndereco || '-'} — ${form.repBairro || '-'}, ${form.repCidade || '-'}/${form.repUf || '-'} — CEP: ${form.repCep || '-'}<br />
    E-mail: ${form.repEmail || '-'} | Telefone: ${form.repTelefone || '-'}</p>
    <p><strong>DOCUMENTOS:</strong> ${documentos}</p>
    <p>Declaração de veracidade: ${BOOL_LABEL(form.declaracaoVerdadeira)}<br />
    Nome para assinatura: ${form.repAssinaturaNome || '-'}</p>
    <p><em>Enviado em ${moment().format('DD/MM/YYYY HH:mm')}</em></p>
  `)
}

export async function submitFichaPj(pfId, form, usuarioCria) {
  const pf = await getReg('pf', pfId)
  if (!pf) throw new Error('Colaborador não encontrado.')

  const now = moment().format('YYYY-MM-DD HH:mm:ss')
  const payload = {
    pf_id: pfId,
    fichaPj_razaoSocial: form.razaoSocial || null,
    fichaPj_cnpj: form.cnpj || null,
    fichaPj_nomeFantasia: form.nomeFantasia || null,
    fichaPj_dtAbertura: form.dtAbertura ? moment(form.dtAbertura).format('YYYY-MM-DD') : null,
    fichaPj_inscMunicipal: form.inscMunicipal || null,
    fichaPj_inscEstadual: form.inscEstadual || null,
    fichaPj_inscEstadualIsento: form.inscEstadualIsento ? 1 : 0,
    fichaPj_endereco: form.endereco || null,
    fichaPj_numero: form.numero || null,
    fichaPj_complemento: form.complemento || null,
    fichaPj_bairro: form.bairro || null,
    fichaPj_cidade: form.cidade || null,
    fichaPj_estado: form.estado || null,
    fichaPj_cep: form.cep || null,
    fichaPj_telefone: form.telefone || null,
    fichaPj_celular: form.celular || null,
    fichaPj_telComercial: form.telComercial || null,
    fichaPj_email: form.email || null,
    fichaPj_obs: form.obs || null,
    fichaPj_tipoServico: form.tipoServico || null,
    fichaPj_porte: form.porte || null,
    fichaPj_ramo: form.ramo || null,
    fichaPj_optanteSimples: form.optanteSimples === '' || form.optanteSimples === null
      ? null
      : (form.optanteSimples ? 1 : 0),
    fichaPj_banco: form.banco || null,
    fichaPj_agencia: form.agencia || null,
    fichaPj_contaNum: form.contaNum || null,
    fichaPj_contaTp: form.contaTp || null,
    fichaPj_estrutura: JSON.stringify(form.estrutura || []),
    fichaPj_possuiContador: form.possuiContador === '' || form.possuiContador === null
      ? null
      : (form.possuiContador ? 1 : 0),
    fichaPj_possuiColaboradores: form.possuiColaboradores === '' || form.possuiColaboradores === null
      ? null
      : (form.possuiColaboradores ? 1 : 0),
    fichaPj_faturamentoMedio: form.faturamentoMedio || null,
    fichaPj_numClientes: form.numClientes || null,
    fichaPj_repNome: form.repNome || null,
    fichaPj_repDtNasc: form.repDtNasc ? moment(form.repDtNasc).format('YYYY-MM-DD') : null,
    fichaPj_repCpf: form.repCpf || null,
    fichaPj_repFormacao: form.repFormacao || null,
    fichaPj_repCelular: form.repCelular || null,
    fichaPj_repWhatsapp: form.repWhatsapp || null,
    fichaPj_repEndereco: form.repEndereco || null,
    fichaPj_repCidade: form.repCidade || null,
    fichaPj_repBairro: form.repBairro || null,
    fichaPj_repUf: form.repUf || null,
    fichaPj_repCep: form.repCep || null,
    fichaPj_repEmail: form.repEmail || null,
    fichaPj_repTelefone: form.repTelefone || null,
    fichaPj_documentos: JSON.stringify(form.documentos || []),
    fichaPj_declaracaoVerdadeira: form.declaracaoVerdadeira ? 1 : 0,
    fichaPj_repAssinaturaNome: form.repAssinaturaNome || null,
    fichaPj_status: 'Não revisado',
    fichaPj_ativo: 1,
    fichaPj_usuarioCria: usuarioCria || pfId,
    fichaPj_usuarioMod: usuarioCria || pfId,
    fichaPj_dtCria: now,
    fichaPj_dtMod: now,
  }

  const fichaPjId = await insert('fichaPj', payload)
  if (!fichaPjId) throw new Error('Não foi possível salvar a ficha no banco de dados.')

  const subject = `Ficha Cadastral PJ — ${pf.pf_nomeExibicao}`
  const html = buildFichaPjEmailHtml(pf, form)
  const cc = pf.pf_emailProf || ''

  await sendEmailToNotify(RH_EMAIL, subject, html, cc)

  return { fichaPjId, pf }
}

export async function searchPfByName(query) {
  const res = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'pf',
    data: { pf_ativo: 1 },
  })}`)
  const list = Array.isArray(res.data) ? res.data : []
  const q = (query || '').trim()
  const regex = q ? new RegExp(q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i') : null
  const filtered = regex
    ? list.filter((p) => regex.test(p.pf_nomeExibicao || '') || regex.test(String(p.pf_id)))
    : list
  return filtered
    .sort((a, b) => (a.pf_nomeExibicao || '').localeCompare(b.pf_nomeExibicao || '', 'pt-BR'))
    .slice(0, 50)
}

export const FICHA_PJ_STATUS = {
  NAO_REVISADO: 'Não revisado',
  APROVADO: 'Aprovado',
}

export async function fetchFichasPj() {
  const res = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'fichaPj',
    data: { fichaPj_ativo: 1 },
    fields: {
      '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = fichaPj.pf_id LIMIT 1)': 'pf_nomeExibicao',
    },
  })}`)
  const list = Array.isArray(res.data) ? res.data : []
  return list.sort((a, b) => {
    const da = a.fichaPj_dtCria ? new Date(a.fichaPj_dtCria).getTime() : 0
    const db = b.fichaPj_dtCria ? new Date(b.fichaPj_dtCria).getTime() : 0
    return db - da
  })
}

export async function updateFichaPjStatus(fichaPjId, status) {
  await updateField('fichaPj', fichaPjId, 'fichaPj_status', status)
}
